const ImageElement = ({
    src,
    imgStyle={},
    alt = "image",
    cssClass = "",
    onClick = () => { },
}) => {
    return (
        <img
            src={src}
            alt={alt}
            style={imgStyle}
            className={`img-fluid ${cssClass}`}
            onClick={onClick}
        />
    );
}

export default ImageElement;